/*
  Product note: re-applies each line's start/expiry window in the browser.
  Liquid already picks the active line at render time, but Shopify caches rendered
  pages, so a temporary message could outlive its expiry (or miss its start) until
  the cache refreshes. Within each note, the first line whose window contains "now"
  is shown; lines without a window always qualify.
*/
(function () {
  function applyWindows() {
    var now = Date.now() / 1000;
    document.querySelectorAll('[data-product-note]').forEach(function (note) {
      var shown = false;
      note.querySelectorAll('.product-note__line').forEach(function (line) {
        var startsAt = Number(line.dataset.startsAt) || 0;
        var expiresAt = Number(line.dataset.expiresAt) || Infinity;
        var active = !shown && now >= startsAt && now < expiresAt;
        line.hidden = !active;
        if (active) shown = true;
      });
      note.hidden = !shown;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWindows);
  } else {
    applyWindows();
  }
})();
